import { render, staticRenderFns } from "./social-distance.vue?vue&type=template&id=2c34e408&scoped=true&"
import script from "./social-distance.vue?vue&type=script&lang=ts&"
export * from "./social-distance.vue?vue&type=script&lang=ts&"
import style0 from "./social-distance.vue?vue&type=style&index=0&id=2c34e408&prod&scoped=true&lang=scss&"
import style1 from "./social-distance.vue?vue&type=style&index=1&id=2c34e408&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c34e408",
  null
  
)

export default component.exports